(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Scrolling-logos"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const section = document.querySelector('.onhow-scrolling-logos-section');
  const track = section?.querySelector('.onhow-scrolling-logos-track');
  if (!track) return;

  const speed = parseFloat(section.dataset.scrollSpeed) || 60;
  const items = Array.from(track.children);
  let totalWidth = track.scrollWidth;
  const parentWidth = track.parentElement.offsetWidth;

  while (totalWidth < parentWidth * 2) {
    items.forEach(item => track.appendChild(item.cloneNode(true)));
    totalWidth = track.scrollWidth;
  }

  const duration = totalWidth / speed;

  const style = document.createElement("style");
  style.innerHTML = `
    @keyframes scrollLogos {
      0% { transform: translateX(0); }
      100% { transform: translateX(-${totalWidth / 2}px); }
    }
    .onhow-scrolling-logos-track {
      animation: scrollLogos ${duration}s linear infinite;
    }
  `;
  document.head.appendChild(style);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["depict-patched-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scrolling-text-carousel"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".scrolling-text-carousel-section");
  const track = section?.querySelector(".scrolling-text-track");
  if (!track) return;

  const speed = parseFloat(section.dataset.scrollSpeed) || 60;
  const items = Array.from(track.children);
  let totalWidth = track.scrollWidth;
  const containerWidth = section.offsetWidth;

  while (totalWidth < containerWidth * 2) {
    items.forEach(item => track.appendChild(item.cloneNode(true)));
    totalWidth = track.scrollWidth;
  }

  const duration = totalWidth / speed;
  const style = document.createElement("style");

  style.innerHTML = `
    @keyframes scrollText {
      0% { transform: translateX(0); }
      100% { transform: translateX(-${totalWidth / 2}px); }
    }
    .scrolling-text-track {
      animation: scrollText ${duration}s linear infinite;
    }
  `;
  document.head.appendChild(style);
});

  } catch(e) { console.error(e); }
})();
})();
